import { S3, S3Client } from "@aws-sdk/client-s3";
import axios from "axios";
import { HmacSHA256, SHA256 } from "crypto-js";
import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { reject } from "lodash";

export const useAws = () => {
  // For export
  let secretId = "ABC1";

    //Easyroll

    const x_api_key = "g6bJOwpduo47CpGrEu8pu9nGXBiaiofK7QFr9NDE";
  
    const accessKey = "AKIAYYWG2ET2URSLVVTP";
    const secretKey = "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";
    const x_api_key_cms = "51kSU4q3Fr6G6UdSka5E71yeu2tsj77Y7yi0Xwam";

    // Global constants
    const s3_region = "ap-northeast-2";
    const aws_region = "us-east-1";
    const aws_service = "execute-api";
  
    // Service
    const api_uri = "easy_rol_public_stage/";
    const api_gateway_host = `bh1bzwe2l6.${aws_service}.${aws_region}.amazonaws.com`;
    const s3_bucket = "easyrol";
  
    // Global variables
    let shared = {
      x_amz_date: null,
      dateStamp: null,
      timeStamp: null,
    };
  
    //Host
    const apiHost = `https://${api_gateway_host}/`;
    const apiStage = `${apiHost}easy_rol_public_stage`;

  // //mjp DEV
  // const accessKey = "AKIA5LF6VHQ6UILMOERB";
  // const secretKey = "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";
  // const x_api_key = "on0tnrfzda77kxqVEUXlR8vAXkKI5ox99GzDJa10";
  // const x_api_key_cms = "B4fOJP9B3V4ECrP3TcIOJ4ZwevZiwy0n7FJ0Mnmj";

  // // Global constants
  // const s3_region = "ap-southeast-1";
  // const aws_region = "ap-southeast-1";
  // const aws_service = "execute-api";

  // // Service
  // const api_uri = "dev_easy_rol_public_stage/";
  // const api_gateway_host = `teua2rsxvi.${aws_service}.${aws_region}.amazonaws.com`;
  // const s3_bucket = "mgpeasyrol";

  // // Global variables
  // let shared = {
  //   x_amz_date: null,
  //   dateStamp: null,
  //   timeStamp: null,
  // };

  // //Host
  // const apiHost = `https://${api_gateway_host}/`;
  // const apiStage = `${apiHost}dev_easy_rol_public_stage`;

  // //mjp PROD
  // const accessKey = "AKIA5LF6VHQ6UILMOERB";
  // const secretKey = "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";
  // const x_api_key = "on0tnrfzda77kxqVEUXlR8vAXkKI5ox99GzDJa10";
  // const x_api_key_cms = "B4fOJP9B3V4ECrP3TcIOJ4ZwevZiwy0n7FJ0Mnmj";

  // // Global constants
  // const s3_region = "ap-southeast-1";
  // const aws_region = "ap-southeast-1";
  // const aws_service = "execute-api";

  // // Service
  // const api_uri = "easy_rol_public_stage/";
  // const api_gateway_host = `nivmzmjxrb.${aws_service}.${aws_region}.amazonaws.com`;
  // const s3_bucket = "mgpeasyrol";

  // // Global variables
  // let shared = {
  //   x_amz_date: null,
  //   dateStamp: null,
  //   timeStamp: null,
  // };

  // //Host
  // const apiHost = `https://${api_gateway_host}/`;
  // const apiStage = `${apiHost}easy_rol_public_stage`;

  /**
   *
   * @param {{HTTPRequestMethod, APIFunction,queryString, requestBody, unauthorize}} input
   * @returns
   */
  const awsHttp = (input) =>
    new Promise((resolve, reject) => {
      const { HTTPRequestMethod, APIFunction, unauthorize } = input;
      let { queryString, requestBody } = input;
      try {
        if (queryString) {
          queryString = convertToURIQueryString(queryString);
        } else {
          queryString = null;
        }

        if (requestBody) {
          requestBody = JSON.stringify(requestBody);
        } else {
          requestBody = null;
        }

        let request_http = apiHost + api_uri + APIFunction;

        if (queryString) {
          request_http += "?";
          request_http = request_http + queryString;
        }

        // Create http header
        var requestHeaders = getRequestHeaders({
          HTTPRequestMethod,
          APIFunction,
          queryString,
          requestBody,
          unauthorize,
        });

        // Create http request option
        var option = {
          body: requestBody,
          headers: requestHeaders,
        };
        return axios
          .request({
            method: HTTPRequestMethod,
            url: request_http,
            data: requestBody,
            headers: requestHeaders,
          })
          .then((res) => {
            return resolve(res);
          })
          .catch((e) => {
            return reject(e);
          });
      } catch (e) {
        return reject(e);
      }
    });

  const getRequestHeaders = ({
    HTTPRequestMethod,
    APIFunction,
    queryString,
    requestBody,
    unauthorize,
  }) => {
    const _header = {
      "Content-Type": "application/json",
      "x-api-key": x_api_key,
    };

    if (!unauthorize) {
      _header["Authorization"] = getAWSAuthorization({
        HTTPRequestMethod,
        APIFunction,
        queryString,
        requestBody,
      });
      _header["X-Amz-Date"] = shared.x_amz_date;
    }
    return _header;
  };

  const init = () => {
    const currentDateTime = new Date();
    shared.dateStamp = formatInTimeZone(currentDateTime, "UTC", "yyyyMMdd");
    shared.timeStamp = formatInTimeZone(currentDateTime, "UTC", "HHmmss");
    shared.x_amz_date = shared.dateStamp + "T" + shared.timeStamp + "Z";
  };

  const getAWSAuthorization = ({
    HTTPRequestMethod,
    APIFunction,
    queryString,
    requestBody,
  }) => {
    init();
    var authorization =
      "AWS4-HMAC-SHA256 Credential=" +
      accessKey +
      "/" +
      shared.dateStamp +
      "/" +
      aws_region +
      "/" +
      aws_service +
      "/" +
      "aws4_request" +
      ", " +
      "SignedHeaders=" +
      "content-type;host;x-amz-date;x-api-key" +
      ", " +
      "Signature=" +
      getSignature({
        HTTPRequestMethod,
        APIFunction,
        queryString,
        requestBody,
      });

    return authorization;
  };

  const getSignature = ({
    HTTPRequestMethod,
    APIFunction,
    queryString,
    requestBody,
  }) => {
    const key = secretKey;
    const kDate = HmacSHA256(shared.dateStamp, "AWS4" + key);
    const kRegion = HmacSHA256(aws_region, kDate);
    const kService = HmacSHA256(aws_service, kRegion);
    const kSigning = HmacSHA256("aws4_request", kService);

    const signature = hexEncode(
      HmacSHA256(
        getStringToSign({
          HTTPRequestMethod,
          APIFunction,
          queryString,
          requestBody,
        }),
        kSigning
      )
    );
    return signature;
  };

  const hexEncode = (obj) => {
    return "" + obj;
  };

  const getStringToSign = ({
    HTTPRequestMethod,
    APIFunction,
    queryString,
    requestBody,
  }) => {
    var Algorithm = "AWS4-HMAC-SHA256";
    var RequestDateTime = shared.x_amz_date;
    var CredentialScope =
      shared.dateStamp +
      "/" +
      aws_region +
      "/" +
      aws_service +
      "/" +
      "aws4_request";
    var HashedCanonicalRequest = SHA256(
      getCanonicalRequest({
        HTTPRequestMethod,
        APIFunction,
        queryString,
        requestBody,
      })
    );
    const StringToSign =
      Algorithm +
      "\n" +
      RequestDateTime +
      "\n" +
      CredentialScope +
      "\n" +
      HashedCanonicalRequest;
    return StringToSign;
  };

  const getCanonicalRequest = ({
    HTTPRequestMethod,
    APIFunction,
    queryString,
    requestBody,
  }) => {
    var CanonicalURI = "/" + api_uri + APIFunction;
    var CanonicalQueryString = "";
    var CanonicalHeaders =
      "content-type:application/json" +
      "\n" +
      "host:" +
      api_gateway_host +
      "\n" +
      "x-amz-date:" +
      shared.x_amz_date +
      "\n" +
      "x-api-key:" +
      x_api_key +
      "\n";
    var SignedHeaders = "content-type;host;x-amz-date;x-api-key";
    var RequestPayload = "";

    if (!queryString || queryString === "") {
      CanonicalQueryString = "";
    } else {
      CanonicalQueryString = queryString;
    }

    if (!requestBody || requestBody === "") {
      RequestPayload = "";
    } else {
      RequestPayload = requestBody;
    }

    const CanonicalRequest =
      HTTPRequestMethod +
      "\n" +
      CanonicalURI +
      "\n" +
      CanonicalQueryString +
      "\n" +
      CanonicalHeaders +
      "\n" +
      SignedHeaders +
      "\n" +
      hexEncode(SHA256(RequestPayload));
    return CanonicalRequest;
  };

  const uploadToS3 = (file, key) =>
    new Promise((resolve, reject) => {
      const s3 = new S3({
        region: s3_region,
        params: { Bucket: s3_bucket },
        credentials: {
          accessKeyId: accessKey,
          secretAccessKey: secretKey,
        },
      });
      // // console.log(file, key, s3_bucket);
      s3.putObject({
        Bucket: s3_bucket,
        Key: key,
        Body: file,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });

  const convertToURIQueryString = (obj) => {
    let str = "";
    for (let key in obj) {
      str += `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}&`;
    }
    str = str.slice(0, str.length - 1);
    return str;
  };

  const getSecretId = (str) => {
    return secretId;
  };

  const setSecretId = (str) => {
    secretId = str;
  };

  return {
    awsHttp,
    getSecretId,
    setSecretId,
    uploadToS3,
    x_api_key,
    apiStage,
    x_api_key_cms,
  };
};
